import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { LocMatCtlM } from 'src/app/shared/models/LocMatCtlM';
import { LocMatCtlWrp } from 'src/app/shared/vo/LocMatCtlWrp';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';

@Component({
  selector: 'app-material-movements',
  templateUrl: './loc-mat-ctl-m.component.html',
  styleUrls: ['./loc-mat-ctl-m.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class LocMatCtlMComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];
  guides: CategoryLan[];
  stores: any[];
  // Se inicializan para que no lance error
  entryTypes: any[] = ['S', 'E'];

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = null;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointPriceExchangeRate = "findMaxExchangeRate";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";
  endPointGetStoreById = "getStoreById";
  endPointListDependentLocalStores = "listDependetLocalStores";
  endPointGetGuidesByYearAndPeriod = "getGuidesByYearAndPeriod";
  endPointGetLoadServs = "getLoadServs";
  endPointGetLoadAmount = "getLoadAmount"
  endPointGetLoadSales = "getSalesCons"
  endPointSavePendAmount = "savePendAmount";
  endPointGetCategotyLang = "getCategoryLang";
  endPointGetMaterialRequest = "getMaterialRequest"
  endPointListOrderGuidesById = "getListOrderGuidesById";
  endPointSearchCategory = "searchCategory";
  endPointUpdateMaterialRequest = "updateMaterialRequest"
  endPointDeleteMaterialRequest = "deleteMaterialRequest"
  endPointGetLocMatCtlM = "getLocMatCtlM";
  endPointGetLocMatCtlH = "getLocMatCtlH";
  endPointCheckOpenOrders = "getCheckOpenOrders";
  endPointGetGuideById = "getGuideById";

  // Rework
  endPointCrudLocMatCtlM = "crudLocMatCtl"

  /** ELEMENT */
  materialReqLst: any[];
  colsGlSales = ['docId', 'sequence', 'dataService', 'status', 'currDate', 'docType', 'packNum', 'totAmt'];

  /**
  * This constructor function initializes various services and variables used in the component, and also
  * checks for authentication based on the token and device parameters passed in the URL.
  * @param {MessageService} messageService - This parameter is of type MessageService and is used for
  * displaying messages to the user. It is likely used to show success or error messages during certain
  * operations.
  * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
  * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
  * confirmation before performing certain actions.
  * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
  * making API requests and handling responses.
  * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
  * which is used to access the current route's information. It provides access to the route's
  * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
  * used to subscribe to the
  * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
  * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
  * the current user's information.
  * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
  * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
  * downloading files.
  * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
  * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
  * on data in the application.
  * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
  * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
  */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private urlBuilderService: UrlBuilderService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private tovpilUtils: TovpilUtilsService,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private translationService: TovpilLanguageService) {

    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.guideId = params.guideId;
      this.dataParent.type = params.type;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
  * The function initializes form groups for configuration and data, and updates the configuration form
  * with query parameters from the route.
  */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    //console.debug("CX3 LGC - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
  * The function `createDataForm` in TypeScript initializes a form group with various form controls and
  * default values, as well as setting some controls as disabled.
  */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: false }),
      selectedPeriod: new FormControl({ value: null, disabled: false }),
      selectedGuide: new FormControl({ value: null, disabled: true }),
      selectedCurrency: new FormControl({ value: null, disabled: true }),

      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedCoordinationLevelId: new FormControl({ value: null, disabled: true }),
    });

    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    //console.debug("CX3 LGC - REACTIVE FORM: " + JSON.stringify(this.globalUserDataForm.value, null, 2));
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.preferences.currentUser = currentUser;

    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      await this.getLanguages();
      await this.getEntryTypes();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    //console.debug("CX3 LGC - LANGUAGES");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;


    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage,
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
    }
  }

  async getEntryTypes() {
    // Salida -> Entrega Materail
    const labelSalida = `${this.translations.lbl_delivery} ${this.translations.lbl_material}`;

    // Entrada -> DEvolucion
    const labelEntrada = `${this.translations.lbl_return} ${this.translations.lbl_material}`;
    this.entryTypes[0] = labelSalida;
    this.entryTypes[1] = labelEntrada;
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string) {
    try {

      if (!storeId) {
        //console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {

        this.globalUserDataForm.patchValue({
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri,
          selectedCoordinationLevelId: result.data?.type ?? ''
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function `getGuideById` asynchronously fetches guide data based on a selected guide ID and
   * updates the global user data form accordingly.
   * @returns This `getGuideById` async function returns a boolean value (`true` or `false`) based on the
   * success of fetching data and updating the value in the `globalUserDataForm`.
   */
  async getGuideById() {
    try {
      const selGuideId = this.dataParent?.guideId || null;

      const data = await this.tovpilCrudService.fetch(this.endPointGetGuideById, {
        "guideId": selGuideId
      });

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }

      this.globalUserDataForm.patchValue({
        selectedGuide: data.data?.guideId + ' ' + data.data?.name + ' ' + data.data?.lastName
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {
      const language = this.globalUserPreferences?.preferences?.language || null;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;

      const validPeriodsResponse = await this.getValidPeriods(language);
      const validGetGuideById = await this.getGuideById();
      const validCoordinationResponse = await this.getCoordination(coordinationStoreId);

      if (validPeriodsResponse && validGetGuideById && validCoordinationResponse) {

        this.getConfigs();
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validPeriodsResponse);
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    if (!this.globalUserDataForm.valid) {
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return;
    }
    try {
      this.blocked = true;
      const salesResponse = await this.getMaterialRequestLst();

      if (salesResponse) {
        //console.debug("CX3 LGC - LOAD DATA: ", salesResponse);
        this.blocked = false;
      } else {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `reloadGetMaterialRequestLst` asynchronously reloads a list of services, displaying an error
   * message if the operation fails.
   */
  async reloadGetMaterialRequestLst() {
    try {
      this.blocked = true;
      const servsResponse = await this.getMaterialRequestLst();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list serve");
        //this.messageService.add({ severity: 'warn', summary: 'REGISTRO CARGOS POR MATERIAL (E/S LOC)', detail: 'Se canceló carga de datos, inténtelo más tarde' });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list serve");
      //this.messageService.add({ severity: 'warn', summary: 'REGISTRO CARGOS POR MATERIAL (E/S LOC)', detail: 'Se canceló carga de datos, inténtelo más tarde' });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `getMaterialRequestLst` is an asynchronous function that fetches a list of sales data and
   * handles success and error cases.
   * @returns a Promise object.
   */
  async getMaterialRequestLst() {
    try {
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selGuideId = this.dataParent.guideId || null;

      let req = {
        year: selYear,
        period: selPeriod,
        guideId: selGuideId,
        language: selLanguage,
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointListOrderGuidesById, req).then(result => {
          //console.debug("CX3 LGC - SERVS: ", req, result)
          if (result.success) {
            this.handleSuccessMaterialRequest(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError(this.translations.lbl_no + ' ' + this.translations.lbl_information + ' ' + this.translations.lbl_to + ' ' + this.translations.lbl_process + ", " + this.translations.lbl_try + ' ' + this.translations.lbl_again);
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function "handleSuccessMaterialRequest" handles the success response of a sales list and extracts the
   * columns dynamically from the JSON data.
   * @param {any[]} data - An array of objects containing sales data.
   */
  async handleSuccessMaterialRequest(data: any[]) {
    if (data.length > 0) {
      try {

        let _data = data.map((item: any) => ({
          ...item,
          canEdit: true
        }));

        // TOTAL
        // _data.push({
        //   docId: " ",
        //   sequence: " ",
        //   dataService: "Total",
        //   status: " ",
        //   currDate: " ",
        //   docType: " ",
        //   packNum: data.reduce((total, item) => total + parseFloat(item?.packNum || .00), .00).toFixed(2),
        //   unitNum: data.reduce((total, item) => total + parseFloat(item?.unitNum || .00), .00).toFixed(2),
        //   totAmt: data.reduce((total, item) => total + parseFloat(item?.totAmt || .00), .00).toFixed(2),
        //   canEdit: false,
        // });

        this.materialReqLst = _data;
      } catch (error) {
        console.error("An error occurred while processing data:", error);
        //this.handleError("Hubo un problema, no hay información que procesar en lista de servicios. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    } else {
      this.materialReqLst = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de servicios. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  async handleError(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {
    try {

      let queryParams = {
        type: this.dataParent.type
      };

      let stringRedirect = '/treasurer/locMatCtlLst';

      const url = this.urlBuilderService.buildUrl(stringRedirect, queryParams);

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigateByUrl(url);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /**
   * The function onRowEditInit takes a parameter commentsf of type any.
   * @param {any} commentsf - The parameter `commentsf` appears to be of type `any`, which means it
   * can hold any type of value. In the context of the function `onRowEditInit`, `commentsf` likely
   * represents some language-related information or configuration. You can use this parameter to perform
   * actions or
   */
  onRowEditInit(commentsf: any) {
    // NOTHING TO DO
  }

  /**
   * The function `onRowEditSave` logs the JSON stringified version of the `commentsf` object when
   * called.
   * @param {any} commentsf - The `commentsf` parameter in the `onRowEditSave` function seems to be
   * an object that contains language-related information. When the function is called, it logs a message
   * indicating that it will edit the `commentsf` object by stringifying it and outputting the result
   * to the
   */
  async onRowEditSave(vw: any) {
    this.blocked = true;
    try {
      let params = {
        "id": vw['docId'],
        "descrip": vw['sequence'],
        "field05": vw['packNum']
      }
      const result = await this.tovpilCrudService.fetch(this.endPointUpdateMaterialRequest, params);

      if (result.success) {
        this.messageService.add({ severity: 'success', summary: `${this.translations.lbl_update} ${this.translations.lbl_orders_request}`, detail: this.translations.lbl_update_data });
        this.blocked = true;
      } else {
        console.error("An error occurred while fetching languages:", result);
        this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_update} ${this.translations.lbl_orders_request}`, detail: `${this.translations.lbl_update} ${this.translations.lbl_cancelled}, ${this.translations.lbl_then_try_it_again}` });
        this.blocked = true;
      }
      this.reloadGetMaterialRequestLst();
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_update} ${this.translations.lbl_orders_request}`, detail: `${this.translations.lbl_update} ${this.translations.lbl_cancelled}, ${this.translations.lbl_then_try_it_again}` });
      this.blocked = false;
    }
  }

  /**
   * The function onRowEditCancel takes a parameter commentsf and does not have any implementation.
   * @param {any} commentsf - The `commentsf` parameter in the `onRowEditCancel` function appears to
   * be of type `any`, which means it can hold any type of value (string, number, object, etc.). You can
   * use this parameter to access the language information related to the row being edited when the
   */
  onRowEditCancel(commentsf: any) {
    // NOTHING TO DO
  }

  /**
   * The function onRowDelete takes a parameter commentsf and does not have any implementation logic.
   * @param {any} commentsf - The `onRowDelete` function seems to be a function that handles deleting a
   * row, possibly from a table or a similar data structure. The `commentsf` parameter is likely the data
   * associated with the row that is being deleted. You can use this parameter to access and manipulate
   * the data related to
   */
  async onRowDelete(vw: any) {
    this.blocked = true;
    try {
      let params: LocMatCtlWrp = {
        locM: {
          id: {
            "year": vw['year'],
            "sequence": vw['sequence'],
          },
        },  
        locD : null,
        language : null,
        method : "DELETE"
      }
      // const result = await this.tovpilCrudService.fetch(this.endPointCrudLocMatCtlM, params);

      const result = await this.apiService.crudLocMatCtl(params);

      if (result != null) {
        this.messageService.add({ severity: 'success', summary: `${this.translations.lbl_delete_record} ${this.translations.lbl_orders_request}`, detail: `${this.translations.lbl_deleted}` });
        this.blocked = true;
      } else {
        console.error("An error occurred while fetching languages:", result);
        this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_delete_record} ${this.translations.lbl_orders_request}`, detail: `${this.translations.lbl_delete_record} ${this.translations.lbl_cancelled},  ${this.translations.lbl_then_try_it_again}` });
        this.blocked = true;
      }
      this.reloadGetMaterialRequestLst();
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_delete_record} ${this.translations.lbl_orders_request}`, detail: `${this.translations.lbl_delete_record} ${this.translations.lbl_cancelled},  ${this.translations.lbl_then_try_it_again}` });
      this.blocked = false;
    }
  }

  /**
   * The function retrieves values from a row of data and then redirects to
   * different functions based on the type of document.
   * @param {any} rowData - The  function takes a `rowData` parameter, which is
   * expected to be an object containing data related to a document. The function extracts various values
   * from this object such as `docId`, `docType`, `wrksId`, etc., and then makes asynchronous
   */
  async redirectToLocMatLstD(rowData: any) {

    // GET VALUES
    const selYear = rowData['year'] ?? null;
    const selDocType = rowData['docType'] ?? null;
    const selWrksId = rowData['wrksId'] ?? null;

    const seq = rowData['sequence'] ?? null;
    const amount = rowData['totAmt'] ?? null;
    const date = rowData['currDate'] ?? null;
    const packageNum = rowData['packNum'] ?? null;
    const status = rowData['status'] ?? null;
    const selLanguage = this.globalUserPreferences?.preferences?.language || null;
    const isOnlyArticles = rowData['wrksId'] ? false : true;

    //console.debug("CX3 LGC - REDIRECT: ", rowData);

    // REDIRECT BASED IN TYPE
    if (selDocType === 'S') {
      this.redirectToSupplyDtl(selDocType, selYear, selWrksId, selLanguage, true, amount, date, packageNum, status, seq, isOnlyArticles);
    } else if (selDocType === 'R') {
      this.redirectToSupplyDtl(selDocType, selYear, selWrksId, selLanguage, true, amount, date, packageNum, status, seq, isOnlyArticles);
    } else {
      this.reloadGetMaterialRequestLst();
    }
  }

  /**
     * The function redirects to a specific page with certain parameters in a
     * TypeScript application.
     * @param {boolean} opt - The function takes a boolean parameter `opt` which
     * determines the value of the `docType` property in the `navigationExtras` object. If `opt` is true,
     * `docType` will be set to "S", otherwise it will be set to "R
     */
  async redirectToSupplyDtl(docType: string, year: string, wrksId: string, language: string, band: boolean, amount: number, date: string, packageNum: number, status: string, sequence: string, isOnlyArticles: boolean) {

    let valid = await this.validateOpenOrders()
    if (!valid && !band) {
      return;
    }


    //console.debug("CX3 LGC - REDIRECT DTL: ", docType, docId, wrksId, language, band);

    try {
      let queryParams = {
        guideId: this.dataParent.guideId || null,
        docType: docType,
        year: year,
        wrksId: wrksId,
        language: language,
        levelId: this.globalUserPreferences?.preferences?.levelId,

        isOnlyArticles: isOnlyArticles,
        sequence: sequence,
        amount: amount,
        date: date,
        package: packageNum,
        status: status,

        type: this.dataParent.type
      };

      let stringRedirect = '/treasurer/locMatCtlDtl';

      const url = this.urlBuilderService.buildUrl(stringRedirect, queryParams);

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigateByUrl(url);

    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      //this.messageService.add({ severity: 'warn', summary: 'SELECCIÓN SOLICITUD DE MATERIAL DETALLE', detail: "Error consultando detalle", life: 5000 });
    }
  }


  /**
   * The function  checks if there are any open orders in the `materialReqLst` array.
   * @returns The  function is returning a boolean value. It checks if there is any
   * item in the `materialReqLst` array with a `status` property equal to 'N'. If such an item is found,
   * it returns `true`, indicating that there are open orders. Otherwise, it returns `false`, indicating
   * that there are no open orders.
   */
  async validateOpenOrders() {
    //console.debug("CX3 LGC - ORDERS VALIDATE ");

    try {
      const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const _language = this.globalUserPreferences?.preferences?.language || null;

      const result = await this.tovpilCrudService.fetch(this.endPointCheckOpenOrders, {
        zoneId: null,
        storeId,
        _language,
      });

      if (result.success) {
        if (!result.data?.valid) {
          this.handleError(`${this.translations.lbl_entry_open_orders}: ` + (result.data?.value ?? " "));
        }
        return result.data?.valid ?? false;
      } else {
        console.error("An error occurred while fetching data:");
        //this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /** MANAGE PREFERENCES */

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    //console.debug("CX3 RCM - ON CHANGE USER PREFERENCES: ")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    this.getLanguages();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataForm.get('selectedPeriod').value) || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }
}
